import React, {ReactElement, useContext} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import britishBusinessBankLogo from '../../../images/BritishBusinessBank-logo.svg';
import fCALogo from '../../../images/FCA-logo.svg';
import {LayoutCircleConfig} from '../Layout/LayoutSection/LayoutSectionCircles';
import RenderOnLocales from '../../../RenderOnLocales';
import LocaleContext, {Locale} from '../../../RootProvider/LocaleContext';
import {Alignment, FormatMessageFunction} from '../../../types';

import './BankingPartnerSection.scss';
import DynamicLink from '../../DynamicLink/DynamicLink';

export enum Size {
  SMALL = 'sizeSmall',
  MEDIUM = 'sizeMedium',
  LARGE = 'sizeLarge',
}

export const britishBusinessBankCircles: LayoutCircleConfig = {
  // @todo: temporarily disabled, should be reinstated when UpdatesBlock is move back to original position
  // desktop: [
  //   {
  //     type: LayoutCircleType.LIGHT,
  //     style: {
  //       width: '29rem',
  //       top: '1rem',
  //       right: '-7rem'
  //     }
  //   }
  // ],
  // tablet: [
  //   {
  //     type: LayoutCircleType.LIGHT,
  //     style: {
  //       width: '29rem',
  //       top: '1rem',
  //       right: '-7rem'
  //     }
  //   }
  // ]
};

const getBankingPartnerHref = (locale: Locale, formatMessage: FormatMessageFunction): string => {
  switch (locale) {
    case Locale.uk:
      return formatMessage({id: 'homepage.bankingPartner.bbb.href'});
    case Locale.nl:
    default:
      // fallback
      return formatMessage({id: 'homepage.bankingPartner.fca.href'});
  }
};

interface BankingPartnerSectionProps {
  hideText?: boolean;
  size?: Size;
  alignment?: Alignment;
}

function BankingPartnerSection({
  hideText,
  size = Size.MEDIUM,
  alignment = Alignment.CENTER,
}: BankingPartnerSectionProps): ReactElement {
  const {formatMessage} = useIntl();
  const locale = useContext(LocaleContext);
  const fcaLogoImage = (
    <img src={fCALogo} alt={formatMessage({id: 'phoenix.formLayoutSidebar.bankingPartner.fca.alt'})} />
  );
  const bbbLogoImage = (
    <img src={britishBusinessBankLogo} alt={formatMessage({id: 'phoenix.formLayoutSidebar.bankingPartner.bbb.alt'})} />
  );

  return (
    <div className={`bankingPartnerSection bankingPartnerSection--${alignment}`}>
      <DynamicLink className="bankingPartnerSection__logoLink" href={getBankingPartnerHref(locale, formatMessage)}>
        <div className="col-xs-12 col-sm-6 col-md-12">
          <div
            className={`bankingPartnerSection__logoLink__logo bankingPartnerSection__logoLink__logo--${size}`.trim()}
          >
            <RenderOnLocales locales={[Locale.uk]} FallbackComponent={fcaLogoImage}>
              {bbbLogoImage}
            </RenderOnLocales>
          </div>
        </div>
      </DynamicLink>
      {!hideText && (
        <div className="bankingPartnerSection__text">
          <RenderOnLocales
            locales={[Locale.uk]}
            FallbackComponent={<FormattedMessage id="homepage.bankingPartner.financialConductAuthority.text" />}
          >
            <FormattedMessage id="homepage.bankingPartner.britishBusinessBank.text" />
          </RenderOnLocales>
        </div>
      )}
    </div>
  );
}

export default BankingPartnerSection;
